module.exports = __webpack_public_path__ + "media/Bike_Horn.cd58190b.mp3";